<template>
    <div class="cart">
        <a :href="'/' + culture + '/shop/review'" onclick="return false;" rel="nofollow" v-on:click="toggleCartSlider(true, Cart.NumberOfCartItems)" class="cart-summary-container2 fadeIn track-GA4-event" data-ga4_name="navigation_click" data-ga4_title="n/a" data-ga4_title1="n/a" data-ga4_click_text="cart" id="cart-summary-container2" :class="Cart.NumberOfCartItems == undefined || Cart.NumberOfCartItems == 0 ? 'cart-summary-empty' : ''">
            <span v-if="!enableDiscoverMode" aria-hidden="true"><i class="glyphicon glyphicon-shopping-cart"></i></span>
            <span v-else aria-hidden="true">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M4.23622 5.68945H2.10352V3.68945H5.97081L7.47081 14.1895H16.8352L18.3019 8.68945H8.10352L11.6035 6.68945H20.9051L18.3718 16.1895H5.73622L4.23622 5.68945Z" />
                    <path fill="currentColor" d="M9.60352 19.1895C9.60352 20.0179 8.93194 20.6895 8.10352 20.6895C7.27509 20.6895 6.60352 20.0179 6.60352 19.1895C6.60352 18.361 7.27509 17.6895 8.10352 17.6895C8.93194 17.6895 9.60352 18.361 9.60352 19.1895Z" />
                    <path fill="currentColor" d="M17.6035 19.1895C17.6035 20.0179 16.9319 20.6895 16.1035 20.6895C15.2751 20.6895 14.6035 20.0179 14.6035 19.1895C14.6035 18.361 15.2751 17.6895 16.1035 17.6895C16.9319 17.6895 17.6035 18.361 17.6035 19.1895Z" />
                </svg>
            </span>
            <span class="sr-only">{{ Cart.NumberOfCartItems }} item(s) in cart</span>
            <span id="summary-NumberOfItems" class="NumberOfItems" v-show="Cart.NumberOfCartItems != undefined && Cart.NumberOfCartItems > 0">{{ Cart.NumberOfCartItems }}</span>
            <span class="NumberOfItems ZeroItems" v-show="Cart.NumberOfCartItems == undefined || Cart.NumberOfCartItems == 0">0</span>
            <span id="summary-total" class="hidden-xs">{{ Cart.TotalToFormat }}</span>
            <span class="sr-only">{{getInterfaceText('cart_total_amount')}} {{ Cart.TotalToFormat }}</span>
        </a>

        <!-- cart slider -->
        <div id="cart-summary-slider" :style="displaySlider" :class="isCartSummaryOpen && ((Cart.CartItems && Cart.CartItems.length > 0) || ignoreItemCount) ? 'slide-out' : 'slide-in'" aria-label="Cart" role="dialog" aria-modal="true" v-if="isOpen" @keydown="handleKeydown" ref="modal">

            <!-- product added mode -->
            <template v-if="(Cart.IsProductAddedMode && Cart.RelatedProducts && Cart.RelatedProducts.length > 0)">

                <div id="title-and-close-button" class="no-border clearfix">
                    <div class="title">
                        <h2>Added to cart</h2>
                    </div>
                    <div class="close-button text-right">
                        <button v-on:click="toggleCartSlider(false)" id="cartCloseButton" aria-label="close" class="btn-close">
                            <svg viewBox="0 0 24 24" width="24" height="24">
                                <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                            </svg>
                        </button>
                    </div> 
                </div>

                <div id="body" class="body-product-just-added" v-show="CartHasItems">
                    <div class="product-just-added" v-if="addedProduct != null">
                        <div class="check">
                            <span class="greencheck">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1 7.61538C3.01428 9.71821 4.14361 10.8972 6.15789 13L15 3" stroke="white" stroke-width="2" />
                                </svg>
                            </span>
                        </div>
                        <div class="image">
                            <img :src="addedProduct.ImageMedium" width="120" />
                        </div>
                        <div class="text">
                            <h3 class="name">
                                {{addedProduct.Name}}<br />
                            </h3>
                            <div class="color-and-size">
                                <span class="color" v-if="addedPartnumber.Color != null && addedPartnumber.Color != ''">{{addedPartnumber.Color}}</span>
                                <span class="divider" v-if="addedPartnumber.Color != null && addedPartnumber.Color != '' && addedPartnumber.Size != null">|</span>
                                <span class="size" v-if="addedProduct.Partnumber.Size != null">{{addedPartnumber.Size}}</span>
                            </div>
                            <!-- price / total -->
                            <div class="price">
                                <span class="sr-only">{{getInterfaceText('shop_price')}} {{addedCartItem.TotalToFormat}}</span>
                                <span class="sr-only" v-if="addedCartItem.TotalOriginalPriceToFormat && addedCartItem.TotalOriginalPriceToFormat.length > 0">{{getInterfaceText('shop_price_original')}} {{addedCartItem.TotalOriginalPriceToFormat}}</span>
                                <div class="cartItem-total newprice" :class="{ 'omnibus-mode': Cart.EnableLowest30DaysPriceMode == true && addedProduct.PriceScenario == 1 }">{{addedCartItem.TotalToFormat}}</div>
                                <span v-if="Cart.EnableLowest30DaysPriceMode == false" class="cartItem-total oldprice">{{addedCartItem.TotalOriginalPriceToFormat}}</span>
                                <span v-if="Cart.EnableLowest30DaysPriceMode && addedProduct.PriceScenario == 1" class="cartItem-total oldprice omnibus-mode">{{addedCartItem.TotalLowest30PriceToFormat }} </span>
                            </div>
                        </div>
                    </div>
                    <div class="actions">
                        <div class="discover-cart-checkout-wrap">
                            <ButtonDiscoverMode :text="getInterfaceText('shop_checkout')"
                                                fullwidth="true"
                                                variant="filled"
                                                :disabled="cartHasOutOfStockItems"
                                                :aria-describedby="cartHasOutOfStockItems ? 'cart-checkout-unavailable-hint' : ''"
                                                @click="redirectToCart" />
                            <TypographyDiscoverMode v-if="cartHasOutOfStockItems"
                                                    id="cart-checkout-unavailable-hint"
                                                    tag="p"
                                                    tag-style="bodySmall"
                                                    class="checkout-unavailable-hint">
                                {{ getInterfaceText('shop_checkout_unavailable_hint') }}
                            </TypographyDiscoverMode>
                        </div>
                        <div class="discover-cart-shopping-wrap">
                            <ButtonDiscoverMode :text="getInterfaceText('shoppingcart')"
                                            variant="outlined"
                                            fullwidth="true"
                                            @click="showFullCart" />
                        </div>
                    </div>
                    <!-- todo: bundels-->
                    <div class="upsell">
                        <RelatedProductsDiscoverMode></RelatedProductsDiscoverMode>
                    </div>
                </div>


            </template>

            <!-- default mode -->
            <template v-else>

                <div id="title-and-close-button" class="clearfix">
                    <div class="title">
                        <TypographyDiscoverMode tag="h2" tag-style="headlineMedium">
                            {{getInterfaceText('shoppingcart')}}
                        </TypographyDiscoverMode>
                    </div>
                    <div class="close-button text-right">
                        <button v-on:click="toggleCartSlider(false)" id="cartCloseButton" aria-label="close" class="btn-close">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" aria-hidden="true" preserveAspectRatio="xMidYMid meet" role="presentation">
                                <path fill="currentColor" fill-rule="evenodd" d="M16.95 18.364 5.635 7.05 7.05 5.636 18.363 16.95z" clip-rule="evenodd"></path>
                                <path fill="currentColor" fill-rule="evenodd" d="M5.636 16.95 16.95 5.636l1.414 1.414L7.051 18.364z" clip-rule="evenodd"></path>
                            </svg>
                        </button>
                    </div>
                </div>

                <div id="body" v-show="CartHasItems">
                    <div v-show="Cart.LockedCart == false">
                        <CartTableDiscoverMode :edit-mode="true" :summary-mode="true"></CartTableDiscoverMode>
                    </div>
                    <div v-show="Cart.LockedCart == true" v-html="Cart.LockedCartDescription"></div>
                </div>

                <div id="body" class="emptycart" v-show="!CartHasItems">

                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="currentColor">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.541 12.0081H27.9542V16.0081L14.541 16.0081L21.541 12.0081Z" fill="currentColor" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M47.6504 16H41.0215L42.5527 20.2285L45.7461 28.2129C46.4762 28.0741 47.2295 28 48 28C54.6274 28 60 33.3726 60 40C60 46.6274 54.6274 52 48 52C41.3726 52 36 46.6274 36 40C36 35.5684 38.4032 31.6994 41.9766 29.6211L40.4707 25.8555L40.4551 25.8203L32.1973 42H27.8301C26.8777 47.6751 21.9458 52 16 52C9.37258 52 4 46.6274 4 40C4 33.3726 9.37258 28 16 28C16.2526 28 16.5032 28.01 16.752 28.0254L20.5488 21.0352L21.1152 19.9883H37.9961L34.6777 12.0078H47.6504V16ZM16 32C11.5817 32 8 35.5817 8 40C8 44.4183 11.5817 48 16 48C19.7277 48 22.86 45.4505 23.748 42H16V38H23.748C22.86 34.5495 19.7277 32 16 32ZM48 32C47.7551 32 47.5128 32.0117 47.2734 32.0332L50.4043 39.8633L46.8574 41.8281L43.4844 33.3945C41.3802 34.8358 40 37.2569 40 40C40 44.4183 43.5817 48 48 48C52.4183 48 56 44.4183 56 40C56 35.5817 52.4183 32 48 32ZM23.4961 23.9883L20.7793 28.9922C24.4404 30.5839 27.1498 33.9466 27.8301 38H29.748L36.9004 23.9883H23.4961Z" fill="currentColor" />
                    </svg>

                    <h3>{{getInterfaceText('shoppingcart_yourcartisempty')}}</h3>

                    <p style="margin-bottom: 24px;">
                        {{getInterfaceText('shoppingcart_whenyouaddproducts')}}
                    </p>

                </div>

                <div id="footer">
                    <div id="totals" v-show="CartHasItems">
                        <CartTotalsDiscoverMode :edit-mode="true" :summary-mode="true"></CartTotalsDiscoverMode>
                    </div>
                    <div id="actions">

                        <div v-show="CartHasItems" class="discover-cart-checkout-actions">
                            <ButtonDiscoverMode id="proceedToCheckoutButton"
                                                :text="getInterfaceText('shop_checkout')"
                                                :fullwidth="true"
                                                :animated="false"
                                                variant="filled"
                                                :disabled="cartHasOutOfStockItems"
                                                :aria-describedby="cartHasOutOfStockItems ? 'cart-checkout-unavailable-hint' : ''"
                                                @click="redirectToCart" />
                            <TypographyDiscoverMode v-if="cartHasOutOfStockItems"
                                                    id="cart-checkout-unavailable-hint"
                                                    tag="p"
                                                    tag-style="bodySmall"
                                                    class="checkout-unavailable-hint">
                                {{ getInterfaceText('shop_checkout_unavailable_hint') }}
                            </TypographyDiscoverMode>
                        </div>

                        <template v-if="!CartHasItems">
                            <ButtonDiscoverMode :text="getInterfaceText('shop_continueshopping')"
                                                href="/"
                                                :fullwidth="true"
                                                variant="outlined" />
                        </template>

                    </div>
                </div>

            </template>

        </div>
        <div class="cart-slider-overlay"
             @click="toggleCartSlider(false)"
             role="button"
             tabindex="-1"
             aria-label="Close cart"></div>
    </div>
</template>  

<script>
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';
    import CartTableDiscoverMode from '@/components/CartTable-DiscoverMode.vue';
    import CartTotalsDiscoverMode from '@/components/CartTotals-DiscoverMode.vue';
    import RelatedProductsDiscoverMode from '@/components/RelatedProducts-DiscoverMode.vue';
    import ButtonDiscoverMode from '@/components/ButtonDiscoverMode.vue';
    import TypographyDiscoverMode from '@/components/TypographyDiscoverMode.vue';
     export default {
        name: 'CartSummary',
        mixins: [cartMixin, generalMixin],
        components: {
            CartTableDiscoverMode,
            CartTotalsDiscoverMode,
            ButtonDiscoverMode,
            TypographyDiscoverMode,
            RelatedProductsDiscoverMode
        },
        data: function () {
            return {
                isCartSummaryOpen: false,
                loading: true,
                culture: window.culture,
                isInTestMode: window.window.inTestMode,
                enableDiscoverMode: window.enableDiscoverMode,
                enableDiscoverModeCart: window.enableDiscoverModeCart,
                ignoreItemCount: window.enableDiscoverMode,
                displaySlider: 'display:none;',
                isOpen: {
                    type: Boolean,
                    default: false
                },
                hasCartCookie: false
            }
        },
        beforeMount() {
            // get summary only when cart cookie exists
            if (this.hasCartCookie) {
                this.getCartSummary(false);
            }
        },
        methods: {
            cookieExists(namePrefix) {
                if (!document || !document.cookie) return false;
                const cookies = document.cookie.split('; ').map(c => c.split('=')[0]);
                return cookies.some(key =>
                    key === namePrefix ||
                    key.toLowerCase() === namePrefix.toLowerCase() ||
                    key.startsWith(namePrefix + '-') // e.g. cart-en-store-...
                );
            },
            redirectToCart: function () {
                if (this.cartHasOutOfStockItems) {
                    return;
                }
                window.location = '/' + this.culture + '/shop/review';
            },
            toggleCartSlider(showSlider, nrOfItems) {
                var hasItems = nrOfItems > 0;
                var that = this;
                
                if (showSlider && (hasItems || this.ignoreItemCount)) {
                    this.displaySlider = 'display:flex';
                    setTimeout(function () {
                        // then slide
                        that.isCartSummaryOpen = true;
                    }, 100);
                    // no scrolling in the body
                    document.body.style.overflow = 'hidden';
                    document.body.classList.add('cart-open');
                    // a360
                    setTimeout(function () {
                        document.getElementById('cartCloseButton').focus();
                    }, 100);
                    // ga4
                    if (hasItems) {
                        this.handleGA4data();
                    }
                } else {
                    this.isCartSummaryOpen = false;
                    setTimeout(function () {
                        // then slide
                        that.displaySlider = 'display:none';
                    }, 100);
                    // scrolling is back 
                    document.body.style.overflow = 'unset';
                    document.body.classList.remove('cart-open');
                    //set focus on link A360
                    document.getElementById('cart-summary-container2').focus();
                    // reset product added status
                    setTimeout(function () {
                        that.ResetProductAddedMode();
                    }, 300); 
                }

                // visible vs hidden for a360
                setTimeout(function () {
                    const myCart = document.getElementById('cart-summary-slider');
                    var cartContainsOpenClass = myCart.classList.contains('slide-out');
                    if (cartContainsOpenClass) {
                        myCart.style.visibility = '';
                    } else {
                        myCart.style.visibility = 'hidden';
                    }
                }, 100);
            },
            handleGA4data: function () {

                //GA4
                var items = [];
                for (var i = 0; i < this.Cart.CartItems.length; i++) {
                    items.push({
                        'item_id': (this.Cart.CartItems[i].Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + this.Cart.CartItems[i].Product.Id.toString(),
                        'item_name': this.Cart.CartItems[i].Product.Name.toLowerCase(),
                        'discount': this.Cart.CartItems[i].Product.Partnumber.PriceOriginal > 0 ? this.Cart.CartItems[i].Product.Partnumber.PriceOriginal - this.Cart.CartItems[i].Product.Partnumber._price : 0,
                        'index': i,
                        'item_brand': this.Cart.CartItems[i].Product.BrandName.toLowerCase(),
                        'item_category': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 0 ? this.Cart.CartItems[i].Product.PageCategories[0].GA_label.toLowerCase() : 'n/a',
                        'item_category2': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 1 ? this.Cart.CartItems[i].Product.PageCategories[1].GA_label.toLowerCase() : 'n/a',
                        'item_category3': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 2 ? this.Cart.CartItems[i].Product.PageCategories[2].GA_label.toLowerCase() : 'n/a',
                        /*'item_list_name': this.Cart.CartItems[i].Product.GA_Category,*/
                        'item_variant': (this.Cart.CartItems[i].Product.Partnumber.Size + (this.Cart.CartItems[i].Product.Partnumber.Color != undefined && this.Cart.CartItems[i].Product.Partnumber.Color.length > 0 ? ' ' + this.Cart.CartItems[i].Product.Partnumber.Color : '')).toLowerCase(),
                        'price': this.Cart.CartItems[i].Product.Partnumber.PriceOriginal,
                        'quantity': this.Cart.CartItems[i].Quantity
                    });
                }
                window.trackEventGlobalAndLocalGA4({
                    'ga4_name': 'view_cart',
                    'ga4_currency': window.currencyCode,
                    'ga4_value': this.Cart.TotalIncludingShippingCosts,
                    'ga4_items': items
                });

                //Related products
                let result = [];
                for (let item of this.Cart.RelatedProducts) {
                    let newItem = {
                        item_id: 'gearproduct-' + item.Id,
                        item_name: item.Name,
                        index: item.Index,
                        item_brand: item.Brand,
                        item_category: item.Category,
                        item_category2: item.Category2,
                        item_category3: item.Category3, 
                        price: item.Price,
                        discount: item.Discount,
                        quantity: 1
                    }
                    result.push(newItem);
                }

                window.trackEventGlobalAndLocalGA4({
                    'ga4_name': 'view_item_list',
                    'ga4_item_list_name': 'complete your rider experience',
                    'ga4_location': 'mini cart',
                    'ga4_items': result
                });
            },
            handleKeydown(event) {
                const focusableElements = this.getFocusableElements();
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];

                if (event.key === 'Tab') {
                    if (event.shiftKey) {
                        // Shift + Tab
                        if (document.activeElement === firstElement) {
                            event.preventDefault();
                            lastElement.focus();
                        }
                    } else {
                        // Tab
                        if (document.activeElement === lastElement) {
                            event.preventDefault();
                            firstElement.focus();
                        }
                    }
                }
            },
            getFocusableElements() {
                return this.$refs.modal.querySelectorAll(
                    'a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
                );
            },
            showFullCart() {
                this.getCartSummary(false);  // of this.getCartSummary(null)
            }
        },
        computed: {
            addedCartItem() {
                const cart = this.Cart;
                if (!cart || !cart.IsProductAddedMode || !cart.AddedProductId || !cart.CartItems) return null;

                const matches = cart.CartItems.filter(
                    ci => ci.Product && ci.Product.Id === cart.AddedProductId
                );

                if (!matches.length) return null;
                // edge case - get the latest added id as you might have 2 versions of the same product
                return matches.reduce((max, item) =>
                    item.Id > max.Id ? item : max
                );
            },
            addedProduct() {
                return this.addedCartItem ? this.addedCartItem.Product : null;
            },
            addedPartnumber() {
                const cart = this.Cart;
                if (!cart || !cart.IsProductAddedMode || !cart.AddedPartnumberCode || !cart.CartItems) return null;
                return cart.CartItems.find(
                    item => item.Product?.Partnumber?.Code === cart.AddedPartnumberCode
                )?.Product?.Partnumber || null;
            },
            cartHasOutOfStockItems() {
                const items = this.Cart && this.Cart.CartItems;
                if (!items || !items.length) {
                    return false;
                }
                return items.some((item) => {
                    if (!item || !item.Stock) {
                        return false;
                    }
                    const c = item.Stock.Code;
                    return c === 0 || c === '0' || c === 'nostock';
                });
            }
        },
        watch: {
            isOpen(newVal) {
                if (newVal) {
                    // Wacht tot de DOM volledig is gerenderd voordat je probeert $refs te gebruiken
                    this.$nextTick(() => {
                        const focusableElements = this.getFocusableElements();
                        if (focusableElements.length) {
                            focusableElements[0].focus(); // Focus op het eerste element bij openen
                        }
                    });
                }
            }
        },
        created() {
            // determine presence of cart cookie (e.g. "cart-en" or "cart-en-store-...")
            const cartPrefix = 'cart-' + window.cultureFull;
            this.hasCartCookie = this.cookieExists(cartPrefix);

            // only parse interface texts when cart cookie present and element exists
            const el = document.getElementById('vue-cart-parameters');
            if (el && el.dataset && el.dataset.interfacetexts) {
                this.interfaceTexts = JSON.parse(el.dataset.interfacetexts);
            }
        }
    }
</script>